<!--
 * @Description: 共享网络课程
 * @Author: PF
 * @Date: 2023-10-08 10:29:32
 * @LastEditors: PF
 * @LastEditTime: 2025-12-01 15:57:59
-->
<template>
  <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
    <template #header>
      <div class="header-left">
        <el-icon class="header-icon">
          <List />
        </el-icon>
        <span class="header-title">共享网络课程</span>
      </div>
      <div class="header-right"> 
        <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
          <el-icon>
            <Close />
          </el-icon>
        </el-button>
      </div>
    </template>
    <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="网络课程名称" v-model="dataGrid.parms.wlkcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="所属专业" v-model="dataGrid.parms.zyid" clearable filterable @change="bindTable()">
                <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="教务课程" v-model="dataGrid.parms.wlkcid" clearable filterable @change="bindTable()">
                <el-option v-for="item in kcData" :key="item.id" :label="item.wlkcmc" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="关键字" v-model="dataGrid.parms.gjz" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="是否推荐" v-model="dataGrid.parms.sftj" clearable filterable @change="bindTable()">
                <el-option value="true" label="是"></el-option>
                <el-option value="false" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <el-button type="primary" @click="tuiJianClick()"><span class="iconfont icon-chuangjian"></span>推荐</el-button>
            <el-button type="primary" @click="quXiaoTuiJIan()"><el-icon><Close /></el-icon>取消推荐</el-button>
            <el-button type="primary" @click="openBangZhu=true">? 帮助说明</el-button>
          </div>
          <!-- 按钮区域 END -->
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="网络课程名称" prop="wlkcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="关键字" prop="gjz" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="是否推荐" prop="sftj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span v-if="scope.row.sftj===true">是</span>
                <span v-if="scope.row.sftj===false">否</span>
              </template>
            </el-table-column>
            <el-table-column label="推荐顺序" prop="tjsx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
            </el-table-column>

            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="180" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </div>
  </el-dialog>
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <bangzhushuoming v-if="openBangZhu" v-model:openDetail="openBangZhu" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, submitDataGridAction, loadSelect, actionPost, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import edit from './edit.vue'
import { successPrompt, warningPrompt } from '@/utils/promptInfo'
import bangzhushuoming from '@/components/bangzhu/bangzhushuoming.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载网络教学专业下拉框
const zyData = ref()
loadSelect({
  url: '/api/v2/wangluojiaoxue/ziyuanku/zhuanyelist',
  data: zyData,
  order: 'zymc',
  sort: 'asc'
})

// 加载网络教学课程下拉框
const kcData = ref()
loadSelect({
  url: '/api/v2/wangluojiaoxue/wangluokecheng/list',
  data: kcData,
  order: 'wlkcmc',
  sort: 'asc'
})
// 加载网络教学创建教师下拉框
const jsData = ref()
loadSelect({
  url: '/api/v2/pdp/jiaozhigong/list',
  data: jsData,
  order: 'gh',
  sort: 'asc'
})
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'tjsx', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.wlkcmc = dataGrid.value.parms.wlkcmc || null
  dataGrid.value.parms.gjz = dataGrid.value.parms.gjz || null
  dataGrid.value.parms.wlkcid = dataGrid.value.parms.wlkcid || null
  dataGrid.value.parms.sftj = dataGrid.value.parms.sftj || null
  dataGrid.value.parms.zyid = dataGrid.value.parms.zyid || null
  dataGrid.value.parms.jsid = JSON.parse(sessionStorage.getItem('USER_INFO')).id
  loadList({
    url: '/api/v2/wangluojiaoxue/wangluokecheng/gongxiangpagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}
bindTable()

// 弹窗
const row = ref()
const openBangZhu = ref(false)
const openEdit = ref(false)
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'gongxiangwangluokecheng') {
      openList.value = true
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)


// 推荐
const tuiJianClick = () => {
  if (dataGrid.value.multipleSelection.length === 0) {
    return warningPrompt('至少选择一行')
  }
  const options = {
    url: '/api/v2/wangluojiaoxue/wangluokecheng/tuijian',
    data: {
      wlkcids: dataGrid.value.multipleSelection
    }
  }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 取消推荐
const quXiaoTuiJIan = () => {
  if (dataGrid.value.multipleSelection.length === 0) {
    return warningPrompt('至少选择一行')
  }
  const options = {
    url: '/api/v2/wangluojiaoxue/wangluokecheng/quxiaotuijian',
    data: {
      wlkcids: dataGrid.value.multipleSelection
    }
  }
  actionPost(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
